import React from 'react'
import '../../resources/templates.css'

function Template3() {
  const user = JSON.parse(localStorage.getItem('resume-user'))
  return (

    <div className='template1-parent'>
      <div className="top d-flex flex-column">
        <h1>{user.firstName.toUpperCase()} {user.lastName.toUpperCase()}</h1>
        <div>
          <p>{user.email}</p>
          <p>{user.address}</p>
          <p>{user.mobileNumber}</p>
        </div>
      </div>
      <div className="divider mt-3"></div>

      <div className="objective mt-3">
        <h3 style={{ backgroundColor: 'lightsteelblue', }}>Objective</h3>
        <hr />
        <p>{user.objective}</p>
      </div>

      <div className="divider mt-3"></div>

      <div className="education mt-3">
        <h3 style={{ backgroundColor: 'lightsteelblue', }}>Education</h3>
        <hr />
        {user.education.map((education) => {
          return <div className='d-flex align-items-center'>
            <h6 ><b>{education.range} : &nbsp;</b></h6>
            <p> <b>{education.qualification}</b> with  <b>{education.percentage}%</b> in {education.institution}</p>
          </div>
        })}
      </div>
      {
        user.experience.length !== 0 && <>

          <div className="divider mt-3"></div>

          <div className="experience mt-3">
            <h3 style={{ backgroundColor: 'lightsteelblue', }}>Experience</h3>
            <hr />
            {user.experience.map((exp) => {
              return <div className='d-flex align-items-center'>
                <h6 ><b>{exp.range} : &nbsp;</b></h6>
                <p> <b>{exp.company}</b> in{" "}  <b>{exp.place}</b></p>
              </div>
            })}
          </div>
        </>
      }



      <div className="divider mt-3"></div>

      {
        user.projects.length !== 0 && <>
          <div className="projects mt-3">
            <h3 style={{ backgroundColor: 'lightsteelblue', }}>Projects</h3>
            <hr />
            {user.projects.map((project) => {
              return <div className='d-flex flex-column'>
                <h6 ><b>{project.title} [{project.range}] {" "}</b></h6>
                <p> {project.description}</p>
              </div>
            })}
          </div>
        </>
      }

      <div className="divider mt-3"></div>

      <div className="projects mt-3">
        <h3 style={{ backgroundColor: 'lightsteelblue', }}>Skills</h3>
        <hr />
        {user.skills.map((skill) => {
          return <p>
            {skill.technology}
          </p>
        })}
      </div>

      <div className="divider mt-3"></div>
      {
        user.intrests.length !== 0 && <>

          <div className="intrests mt-3">
            <h3 style={{ backgroundColor: 'lightsteelblue', }}>Areas of Intrest</h3>

            {user.intrests.map((a) => {
              return <p>
                {a.area}
              </p>
            })}

          </div></>
      }

      <div className="divider mt-3"></div>
      <div className="declaration mt-3">
        <h3 style={{ backgroundColor: 'lightsteelblue', }}>Declaration</h3>
        <hr />
        <div>
          <p>{user.declaration} </p>
        </div>

      </div>


    </div>
  )
}

export default Template3